<template>
  <div>
    <tbody class="table">
      <tr class="header">
        <th rowspan="1" colspan="1" class="year-selector">
          <span
            class="span"
            style="width: 100px; display: inline-block; text-align: center"
          >
            <Select v-model="year" @on-change="getData">
              <Option v-for="item in yearOption" :value="item" :key="item">{{
                item
              }}</Option>
            </Select>
          </span>
        </th>
        <th rowspan="1" colspan="1" class="one-header">
          <span class="span">Classification</span>
        </th>
        <th
          rowspan="1"
          colspan="1"
          class="one-header"
          v-for="item in mounthList"
          :key="item.string"
        >
          <span class="span oneMonth">{{ item.string }}</span>
        </th>
      </tr>

      <template v-for="(oneType, typeIndex) in data">
        <template v-for="(oneSubType, subtypeIndex) in oneType.list">
          <tr :key="typeIndex + '' + subtypeIndex">
            <!-- 分类 -->
            <td
              :rowspan="oneType.list.length"
              colspan="1"
              v-if="subtypeIndex == 0"
            >
              <span class="span td-hearder">
                {{ oneType.type }}
                <i
                  class="iconfont icon-add"
                  @click="openDetail({}, null, oneType.type, null)"
                ></i>
              </span>
            </td>
            <!-- 子分类 -->
            <td rowspan="1" colspan="1" :key="oneSubType.subType">
              <span class="span subType">{{ oneSubType.subType }}</span>
            </td>
            <!-- 每月单格 -->
            <td
              rowspan="1"
              colspan="1"
              v-for="oneMonth in mounthList"
              :key="oneMonth.string"
            >
              <span class="span oneMonth">
                <div
                  class="one-plan"
                  :style="{
                    width: 100 * item.gridNum - 20 + 'px',
                    backgroundColor: item.color,
                  }"
                  v-for="item in getInfo(oneMonth.moment, oneSubType)"
                  :key="item._id"
                  @click="
                    openDetail(
                      item,
                      oneMonth.moment,
                      oneType.type,
                      oneSubType.subType
                    )
                  "
                >
                  {{ item.title }}
                </div>
                <div
                  class="addOne"
                  @click="
                    openDetail(
                      {},
                      oneMonth.moment,
                      oneType.type,
                      oneSubType.subType
                    )
                  "
                >
                  <i class="iconfont icon-add"></i>
                </div>
              </span>
            </td>
          </tr>
        </template>
      </template>
      <tr>
        <td rowspan="1" colspan="1">
          <span class="span td-hearder">
            <i
              class="iconfont icon-add"
              @click="openDetail({}, null, null, null)"
            ></i>
          </span>
        </td>
        <td rowspan="1" colspan="1"></td>
        <td
          rowspan="1"
          colspan="1"
          v-for="oneMonth in mounthList"
          :key="oneMonth.string"
        >
          <span class="span oneMonth"
            ><div
              class="addOne"
              @click="openDetail({}, oneMonth.moment, null, null)"
            >
              <i class="iconfont icon-add"></i>
            </div>
          </span>
        </td>
      </tr>
    </tbody>

    <planningDetailPop
      ref="planningDetailPop"
      @reflash="getData"
    ></planningDetailPop>
  </div>
</template>

<script>
import planningDetailPop from "@/components/planning-detail-pop.vue";
export default {
  components: { planningDetailPop },
  data() {
    return {
      year: "2021",
      yearOption: ["2020", "2021", "2022", "2023", "2024"],
      mounthList: [],
      data: {},
    };
  },
  methods: {
    async getData() {
      let fromTime = this.$moment({
        year: this.year,
        months: 0,
      }).format("YYYY-MM-DD HH:mm:ss");
      let toTime = this.$moment({
        year: parseInt(this.year) + 1,
        months: 0,
      })
        .subtract(1, "days")
        .format("YYYY-MM-DD HH:mm:ss");

      let res = await this.api({
        url: "/scheme/select",
        method: "get",
        errorAlert: false,
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          fromTime: fromTime,
          toTime: toTime,
          page: 1,
          size: 99,
        },
      });

      // 获得总分类
      let output = [];
      res.list.forEach((item) => {
        let typeIndex = -1;

        output.forEach((_item, _index) => {
          if (_item.type == item.type) {
            typeIndex = _index;
          }
        });

        if (typeIndex < 0) {
          output.push({
            type: item.type,
            list: [item],
          });
        } else {
          output[typeIndex].list.push(item);
        }
      });

      // 设置子分类
      let output2 = [];
      output.forEach((item) => {
        let subType = [];
        item.list.forEach((item2) => {
          let subTypeIndex = -1;
          subType.forEach((one_subType, index_subType) => {
            if (one_subType.subType == item2.subType) {
              subTypeIndex = index_subType;
            }
          });

          if (subTypeIndex < 0) {
            subType.push({
              subType: item2.subType,
              list: [item2],
            });
          } else {
            subType[subTypeIndex].list.push(item2);
          }
        });
        output2.push({
          type: item.type,
          list: subType,
        });
      });

      this.data = output2;
      this.renderMonth();
    },

    renderMonth() {
      let mounthList = [];
      for (let index = 0; index < 12; index++) {
        let monthNum = index;
        let oneMoment = this.$moment({
          year: parseInt(this.year),
          months: monthNum,
        });
        console.log(oneMoment.format("YYYY-MM"));

        mounthList.push({
          moment: oneMoment,
          string: oneMoment.format("YYYY-MM"),
        });
      }
      this.mounthList = mounthList;
    },

    // 渲染时通过
    getInfo(moment, oneSubType) {
      let fromTime = moment;
      let toTime = moment.clone().add(1, "months");

      let output = [];
      oneSubType.list.forEach((item) => {
        let startTime = this.$moment(item.startTime);

        let has = startTime.isBetween(fromTime, toTime, null, "[)");

        if (has) {
          let year_end_time = this.$moment(this.year + "-12-31");
          let _endtime = this.$moment(item.endTime).isAfter(year_end_time)
            ? year_end_time
            : this.$moment(item.endTime);

          let gridNum = this.$moment
            .duration(this.$moment(_endtime).diff(item.startTime))
            .asMonths();
          gridNum = Math.ceil(gridNum);
          output.push({
            ...item,
            gridNum,
          });
        }

        if (moment.months() == 0) {
          let isPreYear = startTime.isBefore(moment);
          if (isPreYear) {
            let gridNum = this.$moment
              .duration(this.$moment(item.endTime).diff(moment))
              .asMonths();
            gridNum = Math.ceil(gridNum);
            output.push({
              ...item,
              gridNum,
            });
          }
        }
      });

      return output;
    },

    openDetail(item, moment, type, subType) {
      this.$refs["planningDetailPop"].open(item, moment, type, subType);
    },
  },
  mounted() {
    this.renderMonth();

    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  // width: 100%;
  // overflow-x: scroll;
  position: relative;
  border-left: 1px solid #e8eaec;
  border-top: 1px solid #e8eaec;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8eaec;
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 1px;
    height: 100%;
    border-left: 1px solid #e8eaec;
  }
  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    &:hover td {
      background-color: #ebf7ff;
    }
  }

  td,
  th {
    border-right: 1px solid #e8eaec;
    background-color: #fff;
    transition: background-color 0.2s ease-in-out;

    min-width: 0;
    height: 48px;
    box-sizing: border-box;
    text-align: left;
    text-overflow: ellipsis;
    vertical-align: middle;
    border-bottom: 1px solid #e8eaec;
  }
  th {
    background-color: rgb(248, 248, 248);
  }

  .span {
    padding: 0 10px;
    min-height: 80px;
    line-height: 80px;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    position: relative;
  }

  .td-hearder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.5;
    .iconfont {
      font-size: 20px;
      color: #ccc;
      cursor: pointer;
      align-items: center;
      justify-content: center;
    }
  }

  .subType {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .oneMonth {
    width: 100px;
    .addOne {
      width: 80px;
      height: 100%;
      position: absolute;
      left: 10px;
      top: 3px;
      font-size: 30px;
      color: #ccc;
      opacity: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover .addOne {
      opacity: 1;
    }
  }

  .one-plan {
    position: relative;
    height: 80px;
    color: #fff;
    left: 0;
    top: 0;
    line-height: 40px;
    border-radius: 5px;
    margin: 5px;
    z-index: 99;
    cursor: pointer;
    // &:hover {
    //   opacity: 0.7;
    // }
  }
}
</style>